<div class="text-content" [id]="isNote ? 'note' + data.id : ''"
     [ngClass]="data.isDraft && !editMode ? 'draft-note-background' : data.textContent.isOverview ? 'overview-note-background' : ''">
  <div class="item-header bordered-divided pl-3 pl-xl-4 pr-3" [ngClass]="{'overview-header-note': data.textContent.isOverview && !editMode}"
      (click)="data.isOpen = !data.isOpen">
    <div class="row align-items-center">
      <div class="col-auto d-flex">
        <ng-container *ngIf="displaySelectCheckbox">
          <div class="form-group inline-checkbox-container mr-2 pb-0 mb-0">
            <div *ngIf="!data.isDraft" class="checkbox" (click)="setSelectedItems($event, data)">
              <input type="checkbox" class="form-control" name="item-selected-{{data.id}}" id="item-selected-{{data.id}}" [(ngModel)]="data.checked">
              <label for="item-selected-{{data.id}}"></label>
            </div>
          </div>
        </ng-container>
        <i class="fa" [ngClass]="data.isOpen ? 'fa-angle-down' : 'fa-angle-right'"></i>
        <div class="ml-2">
          <div class="d-flex">
            <div *ngIf="data.textContent.isOverview" class="mr-4">
              <img src="assets/icons/flask.svg" alt="Overview Note" class="note-header-icon" /> Overview Note
            </div>
            <div *ngIf="hasPermission.crm && isCrmNote(data.textContent)">
              <img src="assets/icons/lightning-bolt.svg" alt="Sonar Note" class="note-header-icon" /> Sonar Note
            </div>
          </div>
          <div>
            <ng-container *ngIf="isReferenceNote">
              <a *ngIf="data.textContent.textContentType === 'INDICATION_NOTE'"
                 class="entity-name" target="_blank"
                 (click)="goToReferenceEntity($event)">{{data.textContentOwner.name}}</a>

              <a *ngIf="data.textContent.textContentType === 'COMPANY_NOTE'"
                 class="entity-name" target="_blank"
                 (click)="goToReferenceEntity($event)">{{data.textContentOwner.parentName}}</a>
              <span>&middot;</span>
            </ng-container>
            <ng-container *ngIf="data.textContent && data.textContent['parentEntityName']">{{data.textContent['parentEntityName']}}</ng-container>
            <ng-container *ngIf="isNote && isTaraNote">
              <span class="text-primary-dark bold main-text">
                Posted by
                <img class="tara-note-logo" src="assets/icons/ai/tara-actually/tara-note-logo.svg" alt="TARA" />
                <ng-container *ngIf="data.textContent?.timestamp">- {{data.textContent.timestamp | rmsTzFormat: formatEST: shortDateFormat}}</ng-container>
                <i class="fa fa-envelope-o tara-envelope-icon"></i>
              </span>
            </ng-container>
            <ng-container *ngIf="isNote && !isTaraNote">
              <span class="text-primary-dark bold main-text">
                {{data.isDraft ? '[Draft]' : 'Posted'}} {{data.textContent ? (data.textContent.timestamp | rmsTzFormat: formatEST: '' | rmsTimeagoExtended) : ''}}
                <ng-container *ngIf="data.textContent?.timestamp">- {{data.textContent ? (data.textContent.timestamp | rmsTzFormat: formatEST: shortDateFormat) : ''}}</ng-container>
              </span>
            </ng-container>
            <em>
              <ng-container *ngIf="!isNote">
                {{index === (length - 1) ? 'Posted' : 'Edited'}} {{data.timestamp | rmsTzFormat: formatEST: timestampFormat}}
              </ng-container>
              <span class="last-edited">
            {{data.textContent && data.textContent.wasAutopublished ? '(auto-posted)' : ''}}
          </span>
            </em>
            <span class="created-by" *ngIf="data.createdBy">
          by {{data.createdBy.firstName + ' ' + data.createdBy.lastName}}
              <span *ngIf="!data.createdBy.active" class="user-inactive">(inactive)</span>
        </span>
            <span class="last-edited" *ngIf="data.textContent?.contentStatusType === 'POSTED' && data.textContent?.lastEditedTimestamp">
          {{ data.createdBy ? ' | ' : '' }}
              Last Edited: <span class="last-edited-date">{{data.textContent.lastEditedTimestamp | rmsTzFormat: formatEST: timestampFormat}}</span>
        </span>
          </div>
        </div>
      </div>
      <div class="col-auto ml-auto" *ngIf="displayLastEdit">
        <ng-container *ngIf="headerActions">
          <button type="button" class="btn btn-icon-simple"
            *ngIf="hasPermission.crm && isCrmNote(data.textContent) && crmUtilsService.hasMultipleCrmItems(crmItems)"
            (click)="showTransferCrmModal($event)" rmsOfflineDisable
            [ngbTooltip]="'Associate Note to Different Sonar Record'" placement="bottom">
            <img class="note-button" src="assets/icons/lightning-bolt-only.svg" [alt]="'Associate Note to Different Sonar Record'"/>
          </button>
          <button type="button" class="btn btn-icon-simple"
            (click)="showOverviewConvertModal($event)" rmsOfflineDisable
            [ngbTooltip]="data.textContent?.isOverview ? 'Convert to Note': 'Convert to Overview Note'" placement="bottom">
            <img class="note-button" src="assets/icons/flask-ovn-toggle.svg" [alt]="data.textContent?.isOverview ? 'Convert to Note' : 'Convert to Overview'"/>
          </button>
          <button type="button" class="btn btn-icon-simple"
                  *ngIf="data.textContent?.lastEditedTimestamp && data.textContent?.contentStatusType === 'POSTED'"
                  [ngbTooltip]="'History'"  placement="bottom"
                  (click)="showHistoryModal($event, data, isNote, isReferenceNote)" rmsOfflineDisable>
            <img class="note-button" src="assets/icons/clock.svg" alt="history"/>
          </button>
          <button type="button" class="btn btn-icon-simple" (click)="startReferenceAdditionMode($event, data)" rmsOfflineDisable
                  [title]="textContentService.editMode ? 'Another editor is open' : ''"
                  [disabled]="textContentService.editMode"
                  [ngbTooltip]="'Add References/Tags'"  placement="bottom"
                  *ngIf="allowEdition && !data.isDraft">
            <img class="note-button" src="assets/icons/tags.svg" alt="tags"/>
          </button>
          <button type="button" class="btn btn-icon-simple" (click)="startEditMode($event, data)" rmsOfflineDisable
                  [title]="textContentService.editMode ? 'Another editor is open' : ''"
                  [disabled]="textContentService.editMode"
                  [ngbTooltip]="'Edit Note'"  placement="bottom"
                  *ngIf="allowEdition && !data.textContent['isDisable'] && (data.textContent?.createdBy && data.textContent.createdBy?.id) === currentUser.id && !isReadOnly && isEditable(data)">
                <img class="note-button" src="assets/icons/pencil-notes.svg" alt="edit"/>
          </button>
          <ng-container *ngIf="!isReferenceNote && copyPasteEnabled && (!data.isDraft || (data.isDraft && data.textContent.parentId)) && !isCrmNote(data.textContent)">
            <button type="button" class="btn btn-icon-simple" (click)="copyNote($event,data)"
            [ngbTooltip]="'Copy Note'"  placement="bottom">
              <img class="note-button" src="assets/icons/copy.svg" alt="copy"/>
            </button>
          </ng-container>
          <button type="button"
                  *ngIf="!data.isDraft"
                  class="btn button-link-data btn-icon-simple"
                  [ngbTooltip]="'Copy Link'"  placement="bottom"
                  (click)="copyLink($event,data)">
            <img class="note-button" src="assets/icons/chain.svg" alt="link"/>
          </button>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="note-container" *ngIf="data.isOpen">
    <div class="pl-3 pr-3 note-container-shadow">
      <ng-container *ngIf="editMode">
        <rms-rich-text-editor [elementId]="'itemId'"
                              [content]="editorContent"
                              [enableAutoSave]="true"
                              (autoSave)="onAutoSave($event)"
                              (onEditorChange)="editorChanged($event)">
        </rms-rich-text-editor>
        <rms-text-content-attachments-preview [attachmentList]="attachmentsPreview" *ngIf="attachmentsPreview.length">
        </rms-text-content-attachments-preview>
        <div class="row pt-2 pb-2">
          <div class="col-12 col-md-4">
            <label class="btn btn-primary file-import-field">
              <input type="file" id="fileUploadEditNote" multiple
                    [accept]="allowedFileType"
                    (change)="inputFileChanged($event.target.files)"
                    rmsOfflineDisable>
              {{"FORMS.FILE_IMPORT_LABEL" | translate}}
            </label>
            <span [innerHTML]="fileUploadService.uploadMessage"></span>
            <p style="max-width: 280px" *ngIf="fileUploadService.fileUploadProgress > 0">
              <ngb-progressbar type="info" [value]="fileUploadService.fileUploadProgress" height="10px"></ngb-progressbar>
            </p>
          </div>
          <div class="col-12 col-md-8 text-right">
            <em class="mr-3">{{autoSaveMessage}}</em>
            <ng-container *ngIf="overviewEnabled">
              <span>Overview Note</span>
              <input type="checkbox" [(ngModel)]="data.textContent.isOverview" class="mr-2 mt-2"/>
            </ng-container>
            <button type="button" class="btn btn-default" rmsOfflineDisable
                    *ngIf="data.isDraft && authorizationService.hasPermission([PERMISSIONS.CoreSpaceNoteUpdate])"
                    (click)="showDiscardDraftModal()">Discard Draft</button>
            <button type="button" class="btn btn-default" [disabled]="fileUploadService.uploadInProgress"
                    (click)="saveAsDraft($event)" rmsOfflineDisable>Save as Draft</button>
            <button type="button" class="btn btn-primary" [disabled]="fileUploadService.uploadInProgress"
                    (click)="postItem(editorContent)" rmsOfflineDisable>POST</button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!editMode">
        <rms-crm-item-snapshot *ngIf="hasPermission.crm && crmItem && crmNote && crmNote.itemSnapshot" [item]="crmItem" [note]="crmNote"></rms-crm-item-snapshot>
        <div class="row divider" ></div>
        <rms-financial-snapshot [data]="data.textContent ? data.textContent.financials : data.financials" [attachments]="data.textContent.attachments"
                                *ngIf="!data.isDraft && (data.textContent?.financials || data?.financials)"></rms-financial-snapshot>
        <div class="row divider" ></div>
        <rms-text-content-associated-map [data]="data"
                  *ngIf="displayMaps && !data.isDraft" ></rms-text-content-associated-map>
        <ng-container *ngIf="isTaraNote && data.textContent?.emailMetadata">
          <div class="email-metadata" [class.expanded]="emailMetadataExpanded">
            <div class="email-metadata-body">
              <div class="email-metadata-column">
                <button type="button" class="email-metadata-header" (click)="toggleEmailMetadata()"
                        [attr.aria-expanded]="emailMetadataExpanded">
                  <i class="fa fa-envelope-o email-metadata-icon"></i>
                  <span class="email-metadata-heading">Original email</span>
                  <i *ngIf="emailMetadataExpanded"
                     class="fa fa-angle-right email-metadata-chevron expanded"></i>
                  <ng-container *ngIf="!emailMetadataExpanded && data.textContent.emailMetadata.subject">
                    <span class="email-metadata-divider" aria-hidden="true">|</span>
                    <span class="email-metadata-subject">{{data.textContent.emailMetadata.subject}}</span>
                  </ng-container>
                  <i *ngIf="!emailMetadataExpanded"
                     class="fa fa-angle-right email-metadata-chevron"></i>
                </button>
                <ng-container *ngIf="emailMetadataExpanded">
                <div class="email-metadata-row" *ngIf="data.textContent.emailMetadata.subject">
                  <span class="email-metadata-label"
                        [ngbTooltip]="'Subject of the original email.'" tooltipClass="rms-tooltip" placement="top">Subject: </span>
                  <span class="email-metadata-value">{{data.textContent.emailMetadata.subject}}</span>
                </div>
                <div class="email-metadata-row" *ngIf="data.textContent.emailMetadata.from">
                  <span class="email-metadata-label"
                        [ngbTooltip]="'Sender of the original email.'" tooltipClass="rms-tooltip" placement="top">From: </span>
                  <span class="email-metadata-value">{{data.textContent.emailMetadata.from}}</span>
                </div>
                <div class="email-metadata-row" *ngIf="data.textContent.emailMetadata.toRecipients?.length">
                  <span class="email-metadata-label"
                        [ngbTooltip]="'Recipients of the original email.'" tooltipClass="rms-tooltip" placement="top">To: </span>
                  <span class="email-metadata-value">{{data.textContent.emailMetadata.toRecipients.join(', ')}}</span>
                </div>
                <div class="email-metadata-row" *ngIf="data.textContent.emailMetadata.ccRecipients?.length">
                  <span class="email-metadata-label"
                        [ngbTooltip]="'Additional recipients copied on the original email.'" tooltipClass="rms-tooltip" placement="top">CC: </span>
                  <span class="email-metadata-value">{{data.textContent.emailMetadata.ccRecipients.join(', ')}}</span>
                </div>
                <div class="email-metadata-row" *ngIf="data.textContent.emailMetadata.emailDate">
                  <span class="email-metadata-label"
                        [ngbTooltip]="emailDateTooltip" tooltipClass="rms-tooltip" placement="top">Date: </span>
                  <span class="email-metadata-value">{{data.textContent.emailMetadata.emailDate | rmsTzFormat: formatEST: verboseDateTimeFormat}}</span>
                  <ng-template #emailDateTooltip>
                    Date the original email was sent. RMS uses this as the note's posting timestamp,
                    so the note's information reflects what was accurate when it was originally written
                    &mdash; not when it was forwarded into RMS.
                  </ng-template>
                </div>
                </ng-container>
              </div>
              <div class="email-metadata-column" *ngIf="emailMetadataExpanded">
                <div class="email-metadata-column-title">
                  <i class="fa fa-share email-metadata-icon"></i>
                  <span>Forwarded into RMS</span>
                </div>
                <div class="email-metadata-row" *ngIf="data.textContent.emailMetadata.forwardedToRmsDate">
                  <span class="email-metadata-label"
                        [ngbTooltip]="'Date the email was forwarded into RMS.'" tooltipClass="rms-tooltip" placement="top">Forwarded to RMS: </span>
                  <span class="email-metadata-value">{{data.textContent.emailMetadata.forwardedToRmsDate | rmsTzFormat: formatEST: verboseDateTimeFormat}}</span>
                </div>
                <div class="email-metadata-row" *ngIf="data.textContent.emailMetadata.forwardedBy">
                  <span class="email-metadata-label"
                        [ngbTooltip]="'User who forwarded the email into RMS.'" tooltipClass="rms-tooltip" placement="top">Forwarded By: </span>
                  <span class="email-metadata-value">{{data.textContent.emailMetadata.forwardedBy}}</span>
                </div>
                <div class="email-metadata-row" *ngIf="visibleForwardedToRecipients.length">
                  <span class="email-metadata-label"
                        [ngbTooltip]="'Recipients of the forward.'" tooltipClass="rms-tooltip" placement="top">Forwarded To: </span>
                  <span class="email-metadata-value">{{visibleForwardedToRecipients.join(', ')}}</span>
                </div>
                <div class="email-metadata-row" *ngIf="visibleForwardedCcRecipients.length">
                  <span class="email-metadata-label"
                        [ngbTooltip]="'Additional recipients copied on the forward.'" tooltipClass="rms-tooltip" placement="top">Forwarded CC: </span>
                  <span class="email-metadata-value">{{visibleForwardedCcRecipients.join(', ')}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="email-body-quoted">
            <rms-text-content-body [data]="data.textContent ? data.textContent.content : data.content" *ngIf="!editMode"></rms-text-content-body>
          </div>
        </ng-container>
        <ng-container *ngIf="!isTaraNote || !data.textContent?.emailMetadata">
          <div class="content-body">
            <rms-text-content-body [data]="data.textContent ? data.textContent.content : data.content" *ngIf="!editMode"></rms-text-content-body>
          </div>
        </ng-container>
        <div class="row divider mb-4"
              *ngIf="!data.isDraft && ((displayReferences && data.textContent.references && data.textContent.references.length)
                                        || (data.textContent.tags && data.textContent.tags.length))" ></div>
        <rms-text-content-tags *ngIf="data.textContent.tags && data.textContent.tags.length && !data.isDraft"
                               [tags]="data.textContent.tags" [isReadOnly]="isReadOnly"></rms-text-content-tags>
        <rms-text-content-references *ngIf="displayReferences && data.textContent.references && data.textContent.references.length && !data.isDraft"
                                    [references]="data.textContent.references" [isReadOnly]="isReadOnly"></rms-text-content-references>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #convertOverviewNoteModal let-d="dismiss" let-c="close">
  <div class="overview-note-toggle">
    <div class="modal-header">
      <h4 class="modal-title">
        {{data.textContent?.isOverview ? 'Convert to non-Overview Note' : 'Convert to Overview Note'}}
      </h4>
      <button type="button" class="btn btn-close" aria-label="Close" (click)="d()"></button>
    </div>
    <div class="modal-body">
      <span class="text">
        {{data.textContent?.isOverview ? 'Would you like to convert this Overview Note to a non-Overview Note?' : 'Would you like to convert this note to an Overview Note?'}}
      </span>
      <span class="subtext">*Note that Sonar status cannot be changed.</span>
    </div>
    <div class="modal-footer">
      <div class="btn btn-default" (click)="c()">{{"GENERICS.CANCEL" | translate}}</div>
      <div class="btn btn-primary" (click)="c(data.textContent?.id)">{{"GENERICS.CONFIRM" | translate}}</div>
    </div>
  </div>
</ng-template>

<ng-template #transferCrmModal let-d="dismiss" let-c="close">
  <div class="crm-note-transfer">
    <div class="modal-header">
      <h4 class="modal-title">
        Associate Note to Different Sonar Record
      </h4>
      <button type="button" class="btn btn-close" aria-label="Close" (click)="d()"></button>
    </div>
    <div class="modal-body d-flex flex-column align-items-center">
      <span class="text">
        To associate this note to a different Sonar record, please select the sonar record:
      </span>
      <div
      ngbDropdown
      class="d-inline-block py-3"
      [placement]="['bottom-left', 'bottom-right']"
      >
      <button type="button" class="btn btn-default" ngbDropdownToggle>
        {{(transferCrm && transferCrm.name) || 'Choose Sonar Record ...'}}
      </button>
      <div ngbDropdownMenu>
          <button
            *ngFor="let c of crmUtilsService.getActiveCrmItems(crmItems)"
            ngbDropdownItem
            (click)="transferCrm = c"
            class="pl-2 crm-item-dropdown-item"
            [disabled]="c.id === crmItem.id"
            [ngClass]="{ 'standard': c.itemType === CrmItemType.STANDARD, 'struct-cap': c.itemType === CrmItemType.STRUCT_CAP}"
          >
            <i
            class="fa pr-2 blue"
            [class.fa-circle-o]="crmItem.id !== c.id"
            [class.fa-dot-circle-o]="crmItem.id === c.id">
            </i>{{ c.name }}
          </button>
      </div>
    </div>
    </div>
    <div class="modal-footer">
      <div class="btn btn-default" (click)="c()">{{"GENERICS.CANCEL" | translate}}</div>
      <div class="btn btn-primary" (click)="c({noteId:data.textContent?.id, crmId:transferCrm.id})">{{"GENERICS.SAVE" | translate}}</div>
    </div>
  </div>
</ng-template>

<rms-text-content-history-modal></rms-text-content-history-modal>

<rms-confirmation-modal
  [headerText]="'THESIS.DISCARD'"
  [body]="'THESIS.DISCARD_WARNING'"
  [confirmText]="'Discard'"
  [confirmButtonClass]="'btn-danger'">
</rms-confirmation-modal>
